module.exports = __webpack_public_path__ + "media/images/logos/lowrance-md-1940cc9e2b6dd2f4a26275837f3fb437.png";